import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    Text,
} from '@chakra-ui/react';

const GenerationResultModal = ({ isOpen, onClose, generationTime }) => {
    const formatTime = (time) => {
        const pad = (n) => String(Math.floor(n)).padStart(2, '0');
        const hours = pad(time?.hours || 0);
        const minutes = pad(time?.minutes || 0);
        const seconds = (time?.seconds ?? 0).toFixed(3);
        return `${hours}:${minutes}:${seconds}`;
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Winners Generated</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Text fontSize="lg" fontWeight="medium">
                        Winners generated successfully in {formatTime(generationTime)}
                    </Text>
                </ModalBody>

            </ModalContent>
        </Modal>
    );
};

export default GenerationResultModal;
